export const APP_BASE_URL             =   process.env.REACT_APP_API_SERVER;
export const ISC_API_BASE_URL         =   process.env.REACT_APP_ISC_API_SERVER;
export const INVENTORY_API_BASE_URL   =   process.env.REACT_APP_INVENTORY_API_SERVER;
export const IAM_API_BASE_URL         =   process.env.REACT_APP_IAM_API_SERVER;
export const ORG_API_BASE_URL         =   process.env.REACT_APP_API_SERVER + '/org';


export const APP_BASE_URL_2           =   process.env.REACT_APP_API_SERVER_2;
export const IAM_API_BASE_URL_2       =   process.env.REACT_APP_API_SERVER_4 + '/iam';
export const ISC_API_BASE_URL_2       =   process.env.REACT_APP_API_SERVER_2 + '/isc';
export const ORG_API_BASE_URL_2       =   process.env.REACT_APP_API_SERVER_2 + '/org';
export const HRM_API_BASE_URL_2       =   process.env.REACT_APP_API_SERVER_2 + '/hrm';
export const SCHEDULE_API_BASE_URL_2  =   process.env.REACT_APP_API_SERVER_2 + '/schedule';
export const INVENTORY_API_BASE_URL_2 =   process.env.REACT_APP_API_SERVER_2 + '/inventory';

export const IAM_API_BASE_URL_3       =   process.env.REACT_APP_API_SERVER_2 + '/iam';



/**
 * Org :-
 */
export const ORG_AUTH_URL           =   process.env.REACT_APP_API_SERVER_2    +   '/org';



export const ORG_LOG_URL              =   process.env.REACT_APP_API_SERVER_2    +   '/org/log';


/**
 * Asset Management (IAM)
 */
export const IAM_SUBASSEMBLY_URL      =   process.env.REACT_APP_API_SERVER_2    +   '/iam/sub_assembly';
export const IAM_COUNTERLOG_URL       =   process.env.REACT_APP_API_SERVER_4    +   '/iam/counterlog';


export const IAM_REPORT_URL           =   process.env.REACT_APP_API_SERVER_4    +   '/iam/report';

 // iot

export const IOT_BASE_URL             =   IAM_API_BASE_URL_3    +   '/iot';



/**
 * InVentory
 */
export const ISC_BASE_URL             =   process.env.REACT_APP_API_SERVER_2    +   '/inventory';

export const ISC_INV_ADJUSTMENT_URL   =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/inventory_adjustment';
export const ISC_PURCHASE_URL         =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/purchase';
export const ISC_QUOTATION_URL        =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/quotation';
export const ISC_INV_TRANSFER_URL     =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/inventory_transfer';
export const ISC_REQUISITION_URL      =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/requisition';


export const ISC_SALES_INVOICE_URL    =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/sales_invoice';

export const ISC_REPORT_URL           =   process.env.REACT_APP_API_SERVER_2    +   '/inventory/report';

/**
 * HRM :-
 *  
 */

export const EMP_WORKLOG_URL          =   process.env.REACT_APP_API_SERVER_2    +   '/hrm/work_log';
export const HRMS_EMPLOYEE_URL        =   process.env.REACT_APP_API_SERVER_2    +   '/hrm/employee';




//url for fund transfer
const TapApiUrls = () => {
  return {
    IAM                           :   IAM_API_BASE_URL,
  }
}

export default TapApiUrls()